var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "detailedinformation"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isDetailedInfoLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isDetailedInfoLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.expandAll($event)
      },
      "click": _vm.expandAll
    }
  }, [_vm._v("\n          Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n          Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "InvoiceGSTDetails",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Invoice and GST Details")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "invoicegstdetailsform"
    }
  }, [_c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "200px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("EWB Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("EWB Expiry Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Is EWBN Exempted")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Invoice Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Invoice Value (INR)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.invoiceData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.EWBNumber[index]),
        expression: "form.EWBNumber[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (("" + ((_vm.form.InvoiceValue[index]>=_vm.EBNlimit) && (_vm.form.IsEwbnExempted[index]==0)?'required':''))),
        expression: "`${(form.InvoiceValue[index]>=EBNlimit) && (form.IsEwbnExempted[index]==0)?'required':''}`"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "text",
        "placeholder": "EWB Number",
        "minlength": "12",
        "min": "0",
        "name": _vm.setname(index, 'EWBNumber'),
        "id": _vm.setname(index, 'EWBNumber'),
        "disabled": _vm.editflag || _vm.form.IsEwbnExempted[index] == 1
      },
      domProps: {
        "value": (_vm.form.EWBNumber[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "click": function($event) {
          _vm.clearValidateEwbFlag(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.EWBNumber, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.IsEwbnExempted[index] == 0 && _vm.form.isvalid[index] == 1),
        expression: "form.IsEwbnExempted[index]==0 && form.isvalid[index]==1"
      }],
      staticClass: "fa fa-check fa-2x",
      staticStyle: {
        "color": "green"
      }
    }), _vm._v(" \n                            "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.IsEwbnExempted[index] == 0 && _vm.form.isvalid[index] == 3),
        expression: "form.IsEwbnExempted[index]==0 && form.isvalid[index]==3"
      }],
      staticClass: "fa fa-close fa-2x",
      staticStyle: {
        "color": "red"
      }
    }), _vm._v(" \n                            "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.IsEwbnExempted[index] == 0 && _vm.form.isvalid[index] == 1),
        expression: "form.IsEwbnExempted[index]==0 && form.isvalid[index]==1"
      }],
      staticClass: "fa fa-info-circle fa-2x",
      on: {
        "click": function($event) {
          _vm.openEBNInfoPopup(_vm.form.EWBResponse[index])
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.IsEwbnExempted[index] == 0 && _vm.form.isvalid[index] == 3),
        expression: "form.IsEwbnExempted[index]==0 && form.isvalid[index]==3"
      }],
      staticClass: "fa fa-info-circle fa-2x",
      on: {
        "click": function($event) {
          _vm.openErrorEBNInfoPopup(_vm.form.EWBResponse[index])
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.IsEwbnExempted[index] == 0 && _vm.form.isvalid[index] == 2),
        expression: "form.IsEwbnExempted[index]==0 && form.isvalid[index]==2"
      }],
      staticClass: "fa fa-exclamation-circle  fa-2x",
      on: {
        "click": function($event) {
          _vm.openErrorEBNInfoPopup(_vm.form.EWBResponse[index])
        }
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('invoicegstdetailsform.EWBNumber' + index)),
        expression: "errors.has('invoicegstdetailsform.EWBNumber'+index)"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("EWB Number is required and must be min 12 digits")])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.form.EWBExpiryDate[index]))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.IsEwbnExempted[index]),
        expression: "form.IsEwbnExempted[index]"
      }],
      class: {
        'form-control': true
      },
      staticStyle: {
        "margin": "auto"
      },
      attrs: {
        "type": "checkbox",
        "true-value": "1",
        "false-value": "0",
        "name": "IsEwbnExepmted",
        "id": _vm.setname(index, 'IsEwbnExempted'),
        "name": _vm.setname(index, 'IsEwbnExepmted'),
        "disabled": _vm.editflag
      },
      domProps: {
        "checked": Array.isArray(_vm.form.IsEwbnExempted[index]) ? _vm._i(_vm.form.IsEwbnExempted[index], null) > -1 : _vm._q(_vm.form.IsEwbnExempted[index], "1")
      },
      on: {
        "click": function($event) {
          _vm.clearHSNCheckFlag(index)
        },
        "__c": function($event) {
          var $$a = _vm.form.IsEwbnExempted[index],
            $$el = $event.target,
            $$c = $$el.checked ? ("1") : ("0");
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.form.IsEwbnExempted[index] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.form.IsEwbnExempted[index] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.form.IsEwbnExempted, index, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.HsnCode[index]),
        expression: "form.HsnCode[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (("" + ((_vm.form.IsEwbnExempted[index]=='1')?'required':''))),
        expression: "`${(form.IsEwbnExempted[index]=='1')?'required':''}`"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "text",
        "min": "0",
        "placeholder": "HSN",
        "name": _vm.setname(index, 'HsnCode'),
        "id": _vm.setname(index, 'HsnCode'),
        "disabled": _vm.editflag || _vm.form.IsEwbnExempted[index] != 1
      },
      domProps: {
        "value": (_vm.form.HsnCode[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "click": function($event) {
          _vm.clearHSNFlag(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.HsnCode, index, $event.target.value)
        }
      }
    }), _vm._v("   \n                            "), _c('button', {
      staticClass: "fa fa-save",
      attrs: {
        "type": "button",
        "title": "Verify HSN",
        "name": "button",
        "disabled": _vm.editflag || _vm.form.IsEwbnExempted[index] != 1
      },
      on: {
        "click": function($event) {
          _vm.verifyHsnCode(index)
        }
      }
    })]), _vm._v(" "), (_vm.form.IsEwbnExempted[index] == 1 && _vm.form.ishsnverified[index] == '2') ? _c('span', {
      staticClass: "text-danger errormsg"
    }, [_vm._v("HSN Code Invalid")]) : _vm._e(), _vm._v(" "), (_vm.form.IsEwbnExempted[index] == 1 && _vm.form.ishsnverified[index] == '1') ? _c('span', {
      staticClass: "text-success errormsg"
    }, [_vm._v("HSN Code Verified")]) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('invoicegstdetailsform.HsnCode' + index)),
        expression: "errors.has('invoicegstdetailsform.HsnCode'+index)"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("HSN Code is required")])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.InvoiceNumber[index]),
        expression: "form.InvoiceNumber[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "text",
        "placeholder": "Invoice Number",
        "min": "0",
        "name": _vm.setname(index, 'InvoiceNumber'),
        "id": _vm.setname(index, 'InvoiceNumber'),
        "disabled": _vm.editflag
      },
      domProps: {
        "value": (_vm.form.InvoiceNumber[index])
      },
      on: {
        "click": function($event) {
          _vm.clearValidateEwbFlag(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.InvoiceNumber, index, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('invoicegstdetailsform.InvoiceNumber' + index)),
        expression: "errors.has('invoicegstdetailsform.InvoiceNumber'+index)"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("Invoice Number is required")])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.InvoiceValue[index]),
        expression: "form.InvoiceValue[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "text",
        "min": "0",
        "placeholder": "Invoice Value",
        "name": _vm.setname(index, 'InvoiceValue'),
        "id": _vm.setname(index, 'InvoiceValue'),
        "disabled": _vm.editflag
      },
      domProps: {
        "value": (_vm.form.InvoiceValue[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "click": function($event) {
          _vm.clearValidateEwbFlag(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.InvoiceValue, index, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('invoicegstdetailsform.InvoiceValue' + index)),
        expression: "errors.has('invoicegstdetailsform.InvoiceValue'+index)"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("Invoice Value is required")])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editflag || _vm.form.IsEwbnExempted[index] != '1'),
        expression: "editflag || form.IsEwbnExempted[index]!='1'"
      }],
      staticClass: "-btn btn-success",
      attrs: {
        "type": "button",
        "title": "Validate EWB",
        "disabled": _vm.editflag
      },
      on: {
        "click": function($event) {
          _vm.validateEWB(index)
        }
      }
    }, [_vm._v("Validate EWB")])])])
  }))])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab(1)
      }
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editflag == false),
      expression: "editflag==false"
    }],
    staticClass: "-btn btn-primary1",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save And Next",
      "disabled": _vm.editflag
    },
    on: {
      "click": _vm.checkInvoiceGSTDetailsValidation
    }
  }, [_vm._v("Save And Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ConsigneeDetails",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("Consignee Details")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "consigneedetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row checkbox"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SelfCollectByClient),
      expression: "SelfCollectByClient"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "SelfCollectByClient",
      "name": "SelfCollectByClient",
      "disabled": _vm.editflag || _vm.disableSelfCollectByClient
    },
    domProps: {
      "checked": Array.isArray(_vm.SelfCollectByClient) ? _vm._i(_vm.SelfCollectByClient, "1") > -1 : (_vm.SelfCollectByClient)
    },
    on: {
      "click": _vm.ChkCollectByClient,
      "__c": function($event) {
        var $$a = _vm.SelfCollectByClient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.SelfCollectByClient = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.SelfCollectByClient = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.SelfCollectByClient = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "1"
    }
  }, [_vm._v("Self collect by client "), _c('span', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.checkhover
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "title": "This shipment has to be collected by receiver from destination branch"
    }
  })])]), _c('tooltip', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "tooltip"
    }
  }, [_vm._v("\n                    This shipment has to be collected by receiver from destination branch")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("PinCode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thumb-tack' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PinCode),
      expression: "PinCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "PinCode",
      "id": "PinCode",
      "placeholder": "Enter Pincode",
      "readonly": "",
      "pattern": "^(\\d{6})$",
      "maxlength": 6
    },
    domProps: {
      "value": (_vm.PinCode)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PinCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.PinCode')),
      expression: "errors.has('consigneedetailsform.PinCode')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('consigneedetailsform.PinCode')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("City")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.City),
      expression: "City"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "City",
      "id": "City",
      "placeholder": "Enter City",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.City)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.City = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.City')),
      expression: "errors.has('consigneedetailsform.City')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('consigneedetailsform.City')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("State")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.State),
      expression: "State"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "State",
      "id": "State",
      "placeholder": "Enter State",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.State)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.State = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.State')),
      expression: "errors.has('consigneedetailsform.State')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('consigneedetailsform.State')))])], 1), _vm._v(" "), (_vm.SelfCollectByClient == false) ? _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-top": "27px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editflag == false),
      expression: "editflag==false"
    }],
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Add New Consignee",
      "disabled": _vm.editflag
    },
    on: {
      "click": _vm.addNewConsigneeLocation
    }
  }, [_vm._v("Add New Consignee")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.SelfCollectByClient == false) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AddNewConsigneeFlag == false),
      expression: "AddNewConsigneeFlag==false"
    }],
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Consignee Code")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card-o' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.AddNewConsigneeFlag == false ? 'required' : ''))),
      expression: "`${AddNewConsigneeFlag == false ? 'required' : ''}`"
    }],
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.Consigneelist,
      "placeholder": "Select Consignee",
      "valueFormat": "object",
      "append-to-body": true,
      "name": "Consignee",
      "disabled": _vm.editflag
    },
    on: {
      "input": _vm.selectedConsignee
    },
    model: {
      value: (_vm.Consignee),
      callback: function($$v) {
        _vm.Consignee = $$v
      },
      expression: "Consignee"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.Consignee')),
      expression: "errors.has('consigneedetailsform.Consignee')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Consignee Code is required")])], 1) : _vm._e(), _vm._v(" "), (_vm.SelfCollectByClient == false) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AddNewConsigneeFlag == true),
      expression: "AddNewConsigneeFlag==true"
    }],
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Consignee Code")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ConsigneeCode),
      expression: "ConsigneeCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.AddNewConsigneeFlag == true ? 'required' : ''))),
      expression: "`${AddNewConsigneeFlag == true ? 'required' : ''}`"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ConsigneeCode",
      "id": "ConsigneeCode",
      "placeholder": "Enter Consignee Code",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.ConsigneeCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ConsigneeCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.ConsigneeCode')),
      expression: "errors.has('consigneedetailsform.ConsigneeCode')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Consignee Code field is required")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Company Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-building-o ' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CompanyName),
      expression: "CompanyName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "CompanyName",
      "id": "CompanyName",
      "placeholder": "Enter Company Name ",
      "maxlength": "200",
      "disabled": (_vm.AddNewConsigneeFlag == false && _vm.SelfCollectByClient == false) || _vm.editflag
    },
    domProps: {
      "value": (_vm.CompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CompanyName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.CompanyName')),
      expression: "errors.has('consigneedetailsform.CompanyName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Company Name field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Mobile")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-mobile' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Mobile),
      expression: "Mobile"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:10'),
      expression: "'required|numeric|digits:10'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Mobile",
      "id": "Mobile",
      "placeholder": "Enter Mobile Number",
      "maxlength": "10",
      "pattern": "^[6789](\\d)(?!\\1+$){3,}\\d{8}$",
      "disabled": (_vm.AddNewConsigneeFlag == false && _vm.SelfCollectByClient == false) || _vm.editflag
    },
    domProps: {
      "value": (_vm.Mobile)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.Mobile')),
      expression: "errors.has('consigneedetailsform.Mobile')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('consigneedetailsform.Mobile')))]), _vm._v(" "), (_vm.errors.first('consigneedetailsform.Mobile') == 'The Mobile field format is invalid') ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v("Number Should Start with 6,7,8 or 9")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Consignee POC")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-badge' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ATTN),
      expression: "ATTN"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ATTN",
      "id": "ATTN",
      "placeholder": "Enter Consignee POC",
      "maxlength": "200",
      "disabled": (_vm.AddNewConsigneeFlag == false && _vm.SelfCollectByClient == false) || _vm.editflag
    },
    domProps: {
      "value": (_vm.ATTN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ATTN = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.ATTN')),
      expression: "errors.has('consigneedetailsform.ATTN')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Consignee POC field is required")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Telephone")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-phone' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Telephone),
      expression: "Telephone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Telephone",
      "id": "Telephone",
      "placeholder": "Enter Telephone",
      "maxlength": "12",
      "minlength": "6",
      "disabled": (_vm.AddNewConsigneeFlag == false && _vm.SelfCollectByClient == false) || _vm.editflag
    },
    domProps: {
      "value": (_vm.Telephone)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Telephone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.Telephone')),
      expression: "errors.has('consigneedetailsform.Telephone')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('consigneedetailsform.Telephone')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Email")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope-o' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Email),
      expression: "Email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Email",
      "id": "Email",
      "placeholder": "Enter Email",
      "maxlength": "100",
      "disabled": (_vm.AddNewConsigneeFlag == false && _vm.SelfCollectByClient == false) || _vm.editflag
    },
    domProps: {
      "value": (_vm.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.Email')),
      expression: "errors.has('consigneedetailsform.Email')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('consigneedetailsform.Email')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("GST No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-asterisk' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CSTTINNo),
      expression: "CSTTINNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validate_gst'),
      expression: "'required|validate_gst'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "CSTTINNo",
      "id": "CSTTINNo",
      "placeholder": "Enter GST No",
      "disabled": (_vm.AddNewConsigneeFlag == false && _vm.SelfCollectByClient == false) || _vm.editflag
    },
    domProps: {
      "value": (_vm.CSTTINNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CSTTINNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "gstBlock"
    }
  }, [_vm._v("Note: Allowed GST Format 00XXXXX0000X1ZZ.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.CSTTINNo')),
      expression: "errors.has('consigneedetailsform.CSTTINNo')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter valid format of GST Number")])], 1), _vm._v(" "), (_vm.SelfCollectByClient == false) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Address")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Address),
      expression: "Address"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "Address",
      "name": "Address",
      "placeholder": "Address ",
      "maxlength": "255",
      "disabled": _vm.AddNewConsigneeFlag == false
    },
    domProps: {
      "value": (_vm.Address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('consigneedetailsform.Address')),
      expression: "errors.has('consigneedetailsform.Address')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('consigneedetailsform.Address')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editflag == false),
      expression: "editflag==false"
    }],
    staticClass: "-btn btn-primary1",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save And Next",
      "disabled": _vm.editflag
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab1(2)
      },
      "click": _vm.checkConsigneeDetailsValidation
    }
  }, [_vm._v("Save And Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ShipmentDetails",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("Shipment Details")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "shipmentdetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row "
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Product Categories")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    class: {
      changeColor: _vm.editflag == true
    },
    attrs: {
      "left": "<i class='fa fa-gear'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "multiple": true,
      "max-height": 200,
      "clearable": false,
      "options": _vm.productlist,
      "name": "productcategories",
      "id": "productcategories",
      "placeholder": "Select Product Categories",
      "clear-on-select": true,
      "append-to-body": true,
      "valueFormat": "object",
      "disabled": _vm.editflag
    },
    on: {
      "select": function($event) {
        _vm.selectproductcategories($event)
      }
    },
    model: {
      value: (_vm.productname),
      callback: function($$v) {
        _vm.productname = $$v
      },
      expression: "productname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentdetailsform.productcategories')),
      expression: "errors.has('shipmentdetailsform.productcategories')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Product Categories field is required")])], 1), _vm._v(" "), (this.productname && this.productname.some(function (e) { return e.label === 'Miscellaneous'; })) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Describe Miscellaneous")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card-o' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.misccategory),
      expression: "misccategory"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "misccategory",
      "id": "misccategory",
      "placeholder": "Enter Description",
      "disabled": _vm.editflag
    },
    domProps: {
      "value": (_vm.misccategory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.misccategory = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "misc"
    }
  }, [_vm._v("Note: Please enter comma separated values for multiple miscellaneous categories.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentdetailsform.misccategory')),
      expression: "errors.has('shipmentdetailsform.misccategory')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Miscellaneous description is required")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row "
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Reference No")]), (_vm.referencemandatory) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]) : _vm._e(), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card-o' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReferenceNo),
      expression: "ReferenceNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + ((_vm.referencemandatory)?'required':''))),
      expression: "`${(referencemandatory)?'required':''}`"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ReferenceNo",
      "id": "ReferenceNo",
      "placeholder": "Enter Reference No",
      "maxlength": "200",
      "disabled": _vm.editflag
    },
    domProps: {
      "value": (_vm.ReferenceNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReferenceNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentdetailsform.ReferenceNo')),
      expression: "errors.has('shipmentdetailsform.ReferenceNo')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Reference No field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab1(2)
      }
    }
  }, [_vm._v("Client Reference No")]), (_vm.clientreferencemandatory) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]) : _vm._e(), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientReferenceNo),
      expression: "clientReferenceNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + ((_vm.clientreferencemandatory)?'required':''))),
      expression: "`${(clientreferencemandatory)?'required':''}`"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "clientReferenceNo",
      "id": "clientReferenceNo",
      "placeholder": "Enter Client Reference No",
      "maxlength": "200",
      "disabled": _vm.editflag
    },
    domProps: {
      "value": (_vm.clientReferenceNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientReferenceNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v("(Client Order No.)")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentdetailsform.clientReferenceNo')),
      expression: "errors.has('shipmentdetailsform.clientReferenceNo')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The client Reference No field is required")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editflag == false),
      expression: "editflag==false"
    }],
    staticClass: "-btn btn-primary1",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save And Next",
      "disabled": _vm.editflag
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab2(3)
      },
      "click": _vm.checkShipmentDetailsValidation
    }
  }, [_vm._v("Save And Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[4]),
      expression: "accordianTab[4]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ValueAddedServices",
      "id": "chck4"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[4]) ? _vm._i(_vm.accordianTab[4], null) > -1 : (_vm.accordianTab[4])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(4)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[4] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[4] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 4, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck4"
    }
  }, [_vm._v("Value Added Services")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "valueaddedservicesform"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('legend', [_vm._v(" Appointment Delivery")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Requested Delivery Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RequestedDeliveryDate),
      expression: "RequestedDeliveryDate"
    }],
    staticClass: "deliverydate",
    class: {
      'form-control': true
    },
    attrs: {
      "tabindex": "-1",
      "type": "date",
      "id": "RequestedDeliveryDate",
      "name": "RequestedDeliveryDate",
      "disabled": true,
      "min": _vm.RequestedPickupDate,
      "onkeydown": "return false"
    },
    domProps: {
      "value": (_vm.RequestedDeliveryDate)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.RequestedDeliveryDate = $event.target.value
      }, function($event) {
        _vm.validatedeliverydate()
      }]
    }
  }), _vm._v(" "), _vm._v("  \n                          "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editValueAddedServicesflag),
      expression: "!editValueAddedServicesflag"
    }],
    staticClass: "fa fa-refresh",
    staticStyle: {
      "font-size": "20px",
      "cursor": "pointer",
      "padding-top": "8px",
      "color": "black"
    },
    attrs: {
      "title": "Reset Date"
    },
    on: {
      "click": _vm.refreshDate
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('valueaddedservicesform.RequestedDeliveryDate')),
      expression: "errors.has('valueaddedservicesform.RequestedDeliveryDate')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Requested Delivery Date field is required.")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Requested Delivery Time")]), _vm._v(" "), _c('b-input-group', [_c('span', {
    staticClass: "width",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("From (hrs)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RequestedFromTime),
      expression: "RequestedFromTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time",
      "id": "RequestedFromTime",
      "name": "RequestedFromTime",
      "disabled": true
    },
    domProps: {
      "value": (_vm.RequestedFromTime)
    },
    on: {
      "change": _vm.ValidateTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RequestedFromTime = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('valueaddedservicesform.RequestedFromTime')),
      expression: "errors.has('valueaddedservicesform.RequestedFromTime')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Requested Delivery From Time is required.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-input-group', [_c('span', {
    staticClass: "width",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("To (hrs)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RequestedToTime),
      expression: "RequestedToTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time",
      "id": "RequestedToTime",
      "name": "RequestedToTime",
      "disabled": true
    },
    domProps: {
      "value": (_vm.RequestedToTime)
    },
    on: {
      "change": _vm.ValidateTime,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RequestedToTime = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('valueaddedservicesform.RequestedToTime')),
      expression: "errors.has('valueaddedservicesform.RequestedToTime')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Requested Delivery To Time is required.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('legend', [_vm._v("  Hold Delivery")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "height": "7.4rem"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('span', {
    staticStyle: {
      "color": "#000",
      "padding-right": "5px"
    }
  }, [_vm._v("Hold days ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.HoldDays),
      expression: "HoldDays"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Hold Days",
      "id": "HoldDays",
      "name": "HoldDays",
      "disabled": true
    },
    domProps: {
      "value": (_vm.HoldDays)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.HoldDays = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue",
      "margin-left": "12px"
    }
  }, [_vm._v("(After reaching destination)")]), _vm._v("  \n                      "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('valueaddedservicesform.HoldDays')),
      expression: "errors.has('valueaddedservicesform.HoldDays')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Hold days is required.")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(false) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v(" Value to Collect")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: " row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Collection Amount (INR)")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CollectionAmount),
      expression: "CollectionAmount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Collection Amount",
      "min": "0",
      "id": "CollectionAmount",
      "name": "CollectionAmount",
      "disabled": _vm.editValueAddedServicesflag
    },
    domProps: {
      "value": (_vm.CollectionAmount)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CollectionAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('valueaddedservicesform.CollectionAmount')),
      expression: "errors.has('valueaddedservicesform.CollectionAmount')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Collection Amount is required.")]), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("VTC Payment Mode")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.VTCPaymentList,
      "placeholder": "Select VTC Payment Mode",
      "append-to-body": true,
      "name": "VTCPayment",
      "disabled": _vm.editValueAddedServicesflag
    },
    on: {
      "input": _vm.selectedVTCPayment
    },
    model: {
      value: (_vm.VTCPayment),
      callback: function($$v) {
        _vm.VTCPayment = $$v
      },
      expression: "VTCPayment"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('valueaddedservicesform.VTCPayment')),
      expression: "errors.has('valueaddedservicesform.VTCPayment')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("VTC Payment Mode is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Beneficiary Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Beneficiary),
      expression: "Beneficiary"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + ((_vm.VTCPayment=='Cheque' || _vm.VTCPayment=='Demand Draft (DD)')?'required':''))),
      expression: "`${(VTCPayment=='Cheque' || VTCPayment=='Demand Draft (DD)')?'required':''}`"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Beneficiary",
      "id": "Beneficiary",
      "placeholder": "Enter Beneficiary Name",
      "maxlength": 50,
      "disabled": _vm.editValueAddedServicesflag
    },
    domProps: {
      "value": (_vm.Beneficiary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Beneficiary = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("(Applicable for payment mode of cheque and DD only)")]), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('valueaddedservicesform.Beneficiary')),
      expression: "errors.has('valueaddedservicesform.Beneficiary')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('valueaddedservicesform.Beneficiary')))])], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row checkbox"
  }, [_vm._v("    \n                      "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab3(4)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.MallDelivery),
      expression: "MallDelivery"
    }],
    attrs: {
      "type": "checkbox",
      "id": "MallDelivery",
      "name": "MallDelivery",
      "disabled": _vm.editValueAddedServicesflag || _vm.SelfCollectByClient == true
    },
    domProps: {
      "checked": Array.isArray(_vm.MallDelivery) ? _vm._i(_vm.MallDelivery, null) > -1 : (_vm.MallDelivery)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.MallDelivery,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.MallDelivery = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.MallDelivery = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.MallDelivery = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Is Mall Delivery?")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("Total Invoice Amount (INR): " + _vm._s(_vm.totalinvoicevalue))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editflag == false),
      expression: "editflag==false"
    }],
    staticClass: "-btn btn-primary1",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save",
      "disabled": _vm.editValueAddedServicesflag || _vm.editflag
    },
    on: {
      "click": _vm.saveDetailedInformation
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right",
      "padding": "10px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editflag == false),
      expression: "editflag==false"
    }],
    staticClass: "-btn btn-primary1",
    attrs: {
      "type": "button",
      "title": "Save And Next",
      "disabled": _vm.ofdflag || _vm.editflag
    },
    on: {
      "click": _vm.saveDetailedInformation
    }
  }, [_vm._v("Save And Next  "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])], 1), _vm._v(" "), _c('b-modal', {
    on: {
      "ok": function($event) {
        _vm.EBNInfoPopup == false
      }
    },
    model: {
      value: (_vm.EBNInfoPopup),
      callback: function($$v) {
        _vm.EBNInfoPopup = $$v
      },
      expression: "EBNInfoPopup"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('label', [_c('strong', [_vm._v("Invoice Details ")])])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": _vm.closeEBNInfoPopup
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("HSN")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("GST %")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("CGST (INR)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("SGST (INR)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IGST (INR)")])])]), _vm._v(" "), _vm._l((_vm.hsnlist), function(val, index) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(val.hsnCode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(val.GST))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(val.cgstRate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(val.sgstRate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(val.igstRate))])])])
  })], 2)])])])], 1)]), _vm._v(" "), _c('b-modal', {
    on: {
      "ok": function($event) {
        _vm.EBNInfoErrorPopup == false
      }
    },
    model: {
      value: (_vm.EBNInfoErrorPopup),
      callback: function($$v) {
        _vm.EBNInfoErrorPopup = $$v
      },
      expression: "EBNInfoErrorPopup"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('label', [_c('strong', [_vm._v("Error ")])])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": _vm.closeErrorEBNInfoPopup
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ol', {
    staticStyle: {
      "color": "#000"
    }
  }, _vm._l((_vm.ewbDetailsErrorList), function(val, index) {
    return _c('li', [_vm._v(_vm._s(val))])
  }))])])])], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90d50d24","hasScoped":true}!./src/modules/cargobooking/views/booking/Information/detailedinformation/detailedinformation.component.html
// module id = 1138
// module chunks = 3